import type { FC } from "react";
import { GradientSvg } from "./utils/gradient-svg";

export const GradientMegaphone: FC = () => {
  return (
    <GradientSvg viewBox="0 0 24 24" gradientId="gradientMegaphone" height={32} width={32}>
      <path
        d="M16 7.56641C16 8.23641 16 8.89641 16 9.56641C17.2 9.56641 18.76 9.56641 20 9.56641C20 8.89641 20 8.23641 20 7.56641C18.76 7.56641 17.2 7.56641 16 7.56641Z"
        fill="url(#gradientMegaphone)"
      />
      <path
        d="M14 14.1764C14.96 14.8864 16.21 15.8264 17.2 16.5664C17.6 16.0364 18 15.4964 18.4 14.9664C17.41 14.2264 16.16 13.2864 15.2 12.5664C14.8 13.1064 14.4 13.6464 14 14.1764Z"
        fill="url(#gradientMegaphone)"
      />
      <path
        d="M18.4 2.16641C18 1.63641 17.6 1.09641 17.2 0.566406C16.21 1.30641 14.96 2.24641 14 2.96641C14.4 3.49641 14.8 4.03641 15.2 4.56641C16.16 3.84641 17.41 2.91641 18.4 2.16641Z"
        fill="url(#gradientMegaphone)"
      />
      <path
        d="M2 5.56641C0.9 5.56641 0 6.46641 0 7.56641V9.56641C0 10.6664 0.9 11.5664 2 11.5664H3V15.5664H5V11.5664H6L11 14.5664V2.56641L6 5.56641H2ZM7.03 7.27641L9 6.09641V11.0364L7.03 9.85641L6.55 9.56641H2V7.56641H6.55L7.03 7.27641Z"
        fill="url(#gradientMegaphone)"
      />
      <path
        d="M13.5 8.56641C13.5 7.23641 12.92 6.03641 12 5.21641V11.9064C12.92 11.0964 13.5 9.89641 13.5 8.56641Z"
        fill="url(#gradientMegaphone)"
      />
    </GradientSvg>
  );
};
